import { Component, QueryList, ViewChildren } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { AfTranslateDirective } from '../../../shared/modules/translate/directive/af-translate.directive';
import { HorizontalPollGraphComponent } from '../../../shared/components/horizontal-poll-graph/horizontal-poll-graph.component';
import { NgShowDirective } from '../../../shared/directives/ng-show/ng-show.directive';
import { Tooltip, TooltipModule } from 'primeng/tooltip';
import { AfTranslatePipe } from '@shared/modules/translate/pipe/af-translate.pipe';
import html2canvas from 'html2canvas';
import { RiskBarGraphComponent } from "../risk-bar-graph/risk-bar-graph.component";

@Component({
    selector: 'view-extended-report',
    templateUrl: './view-extended-report.component.html',
    standalone: true,
    imports: [
    NgShowDirective,
    HorizontalPollGraphComponent,
    AfTranslateDirective,
    TooltipModule,
    AfTranslatePipe,
    RiskBarGraphComponent
]
})

export class ViewExtendedReportComponent {
  disabledSaveAsPng: boolean = false;
  showTooltip: boolean = false;
  isModal: boolean=true;
  additionalInfo: any = this.dialogConfig.data.additionalInfo;
  type: string = this.dialogConfig.data.type;
  graphData: any = this.dialogConfig.data.graphData;

  constructor(private dialogRef: DynamicDialogRef<ViewExtendedReportComponent>,
      private dialogConfig: DynamicDialogConfig) { }
  
  @ViewChildren(Tooltip) tooltips: QueryList<Tooltip>;

  saveAsPng(tooltipId: any, elementId: string){
    let documentObject:any = document;
    let that = this;
    let tooltip = this.getTooltip(tooltipId);
    that.disabledSaveAsPng = true;
    setTimeout(() => {
      html2canvas(documentObject.querySelector(elementId))
      .then(function(canvas) {
          canvas.toBlob((blob:any)=>{
              let data = [new ClipboardItem({ [blob.type]: blob })];
              navigator.clipboard.write(data)
                  .then(() => {}, (err) => console.log(err));
          });
          that.disabledSaveAsPng = false;
          that.showTooltip = true;
          setTimeout(()=>{
            tooltip.show();
          }, 100)
          setTimeout(()=>{
              tooltip.hide();
              that.showTooltip = false;
          }, 3000);
      });
    }, 100);
  }

  getTooltip(id:any){
    let tooltip: any = this.tooltips.find((x:any)=>{
      return x.el.nativeElement.id == id;
    });
    return tooltip;
  }

  handleDismiss() {
    this.dialogRef.close({result:'cancel'});
  };

}
